import { render } from "./search-form.vue?vue&type=template&id=38723984&scoped=true"
import script from "./search-form.vue?vue&type=script&lang=js"
export * from "./search-form.vue?vue&type=script&lang=js"

import "./search-form.vue?vue&type=style&index=0&id=38723984&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38723984"]])

export default __exports__